/** @format */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const SCROLL_TO_QUERY_PARAM_ID = "card";

type CardState = {
  scrollToUUID: string | undefined;
};

export const initialState: CardState = {
  scrollToUUID: undefined,
};

export const cardsSlice = createSlice({
  name: "cards",
  initialState,
  reducers: {
    setScrollTo: (state, action: PayloadAction<string | undefined>) => {
      state.scrollToUUID = action.payload;
    },
  },
});

export const { setScrollTo } = cardsSlice.actions;
export default cardsSlice.reducer;
